import $ from "jquery";
import { autorun, observable } from "mobx";

export const loaderState = observable({
  showLoader: true,
});

$(document).on("ready", () => {
  const loader = $(".event-loader");
  if (!loader.length) return;

  loaderState.showLoader = false;

  autorun(() => {
    if (loaderState.showLoader) {
      $("body").addClass("no-scroll");
      loader.addClass("fade-in");
    } else {
      $("body").removeClass("no-scroll");
      loader.removeClass("init").removeClass("fade-in");
      loader.addClass("fade-out");
    }
  });
});
